import { renderName } from "../../../libs/getInitialLetters";
import "./index.scss";

export function HeaderMiniCardList({
  img,
  name,
  more,
  id,
  hoverButtonAdditionalsCard,
  setHoverButtonAdditionalsCard,
  children,
}: {
  img: string;
  name: string;
  id?: number;
  more?: boolean;
  hoverButtonAdditionalsCard?: any;
  setHoverButtonAdditionalsCard?: any;
  children?: any;
}) {
  return (
    <div className={`w-full h-44 rounded-t-xl bg-primary flex justify-center items-center`}>
      {" "}
      {img ? (
        <img className="size-120px rounded-full" src={img} />
      ) : (
        <h2 className="title-without-image size-120px">
          <span className="limit-5-char"> {renderName(name)} </span>
        </h2>
      )}
      {more && (
        <>
          <div
            onMouseEnter={() => {
              setHoverButtonAdditionalsCard({ status: true, id });
              setTimeout(() => setHoverButtonAdditionalsCard({ status: true, id }), 450);
            }}
            onMouseLeave={() => setTimeout(() => setHoverButtonAdditionalsCard(undefined), 500)}
            className="absolute bg-background rounded-lg -mt-32 -mr-60 flex items-center justify-center w-10 h-7"
          >
            {hoverButtonAdditionalsCard?.status && hoverButtonAdditionalsCard?.id === id && (
              <div className="absolute flex justify-between -mt-24 brightness-100 bg-white min-w-max h-12 rounded-xl shadow-xl px-3 text-primary">
                {children}
              </div>
            )}
            <span className="-mt-8 text-primary text-center text-5xl">...</span>
          </div>
        </>
      )}
    </div>
  );
}
